import React from "react"

const Paypal = () => {
  return (
    <form action="https://www.paypal.com/donate" method="post" target="_top" className="text-center p-3">

      <input type="hidden" name="hosted_button_id" value="64WRW7NM68W7G" />

      <input type="image" src="https://www.paypalobjects.com/en_US/GB/i/btn/btn_donateCC_LG.gif" border="0"
             name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />

      <img alt="" border="0" src="https://www.paypal.com/en_GB/i/scr/pixel.gif" width="1" height="1" />

    </form>
  )
}

export default Paypal